<!-- 売場分析のための棚割パターン指定コンポーネント

商品選択をコピーしているので、所々商品的なものが残っているかもですが
もともと汎用的なコンポーネントではないのでちゃんと不要部分を消すつもりは
ありません。
-->

<template>
  <div>
    <div class="item-select-methods button-group">
      <gl-button
        class="button-group__button"
        primary
        @click="patternDialogOpen = true"
      >
        棚割パターンを検索する
      </gl-button>
    </div>
    <div class="items-container" :class="{ 'no-item': items.length === 0 }">
      <filter-tanawari-pattern-list
        :items="items"
        @update:items="$emit('update:items', $event)"
        deletable
      />
    </div>
    <div class="actions button-group">
      <div class="left"></div>
      <span
        class="item-count"
        :class="{ 'exceeds-limit': items.length > maxItems }"
        >{{ itemCount }} / {{ maxItems }}</span
      >
      <gl-button class="button-group__button" raised @click="removeAll"
        >全削除</gl-button
      >
    </div>

    <md-dialog
      class="item-select-dialog"
      :md-active="patternDialogOpen"
      @md-clicked-outside="patternDialogOpen = false"
    >
      <md-dialog-content>
        <filter-tanawari-pattern-search
          :company="company"
          :date-from="dateFrom"
          :date-to="dateTo"
          :categories="categories"
          :exclude-other-category-items="excludeOtherCategoryItems"
          @update:excludeOtherCategoryItems="
            $emit('update:excludeOtherCategoryItems', $event)
          "
          @update:categories="$emit('update:categories', $event)"
          @selected="addItems"
        />
        <gl-button
          class="button-dialog-close"
          icon-button
          @click="patternDialogOpen = false"
          ><md-icon>cancel</md-icon></gl-button
        >
      </md-dialog-content>
    </md-dialog>
  </div>
</template>

<script>
import FilterTanawariPatternSearch from '@/components/FilterTanawariPatternSearch.vue'
import FilterTanawariPatternList from '@/components/FilterTanawariPatternList.vue'
import ErrorReport from '@/mixins/ErrorReport'

// const MAX_ITEMS = process.env.VUE_APP_MAX_ITEMS
//   ? Number(process.env.VUE_APP_MAX_ITEMS)
//   : 500
// 限られたユーザーしか使わない画面なので、選択パターン上限は
// envには記載しません。
const MAX_ITEMS = 20

/**
 * 商品選択コンポーネント
 */
export default {
  components: {
    FilterTanawariPatternSearch,
    FilterTanawariPatternList,
  },
  mixins: [ErrorReport],
  props: {
    /**
     * 企業コード
     */
    company: {
      type: String,
    },
    /**
     * 棚割パターンを検索する範囲
     */
    dateFrom: {
      type: String,
    },
    dateTo: {
      type: String,
    },
    categories: {
      type: Array,
      default: () => [],
    },
    excludeOtherCategoryItems: {
      type: Boolean,
      default: false,
    },
    /**
     * 分析対象棚割コード一覧
     */
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      /**
       * 選択可能な最大数
       */
      maxItems: MAX_ITEMS,

      /**
       * 前回選択企業
       */
      lastCompany: undefined,
      /**
       * パターン検索ダイアログの開閉状態
       */
      patternDialogOpen: false,
    }
  },
  computed: {
    /**
     * 選択されているアイテム数
     */
    itemCount() {
      return this.items.length
    },
    errors() {
      const errors = []

      if (this.items.length === 0) {
        errors.push('棚割パターンを選択してください')
      }

      if (this.items.length > this.maxItems) {
        errors.push(
          `選択できる棚割パターン数は${this.maxItems}パターンまでです`,
        )
      }

      return errors
    },
  },
  methods: {
    /**
     * 商品一覧クリア
     */
    removeAll() {
      this.$emit('update:items', [])
    },
    /**
     * 商品の追加
     */
    addItems(items) {
      const newItemCodes = items.map(i => i.code)

      // TODO パフォーマンスで課題が出たら修正
      this.$emit('update:items', [
        ...this.items.filter(i => !newItemCodes.includes(i.code)),
        ...items,
      ])
      this.patternDialogOpen = false
    },
  },
  watch: {
    company: {
      immediate: true,
      async handler(company) {
        if (company && this.lastCompany && company !== this.lastCompany) {
          this.$emit('update:items', [])
        }
        this.lastCompany = company
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.items-container {
  position: relative;
  height: 250px;
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid var(--color-border);
  border-radius: 5px;
}

.no-item {
  background: rgba(0, 0, 0, 0.12);

  &::after {
    font-family: 'Material Icons';
    content: 'mood_bad';
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    font-size: 58px;
    color: rgba(0, 0, 0, 0.12);
  }
}

.item-select-dialog {
  min-width: 700px;
}

.button-dialog-close {
  position: fixed;
  top: 6px;
  right: 0;
}

.item-select-methods,
.item-select,
.items-container {
  margin-top: var(--spacing-medium);
}

.item-select {
  padding-left: calc(var(--spacing-large) * 2);
}

.actions {
  width: 100%;
  text-align: right;
  display: flex;
  align-items: center;

  .left {
    flex: 1;
  }
}

.item-count {
  margin-right: var(--spacing-medium);
}

.exceeds-limit {
  color: var(--color-warn);
}
</style>
